export default __webpack_public_path__ + "44460ff1b50fa458299a2af927652138.jpeg";